<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" >
      <div class="modal-wrapper">
        <div class="modal-dialog" @click.stop style="overflow-y: initial !important">
          <div class="modal-content">

            <!-- HEADER -->
            <div class="modal-header">
              <h2 class="modal-title font-bold">{{ $t("Report problem") }}</h2>
              <button @click="close" type="button" class="close p-l-20 p-t-5 text-info" aria-hidden="true" data-dismiss="modal"><i class="ti-close"></i></button>
            </div>

            <!-- BODY -->
            <div class="modal-body">
              <div class="form-horizontal">

                <div class="form-group row">
                  <div class="col-sm-12">
                    <span><small class="text-muted">{{ $t("KPI") }}</small></span>
                  </div>
                  <div class="col-sm-12">
                    <span>{{ kpi_name }}</span>
                    <span>{{ date_time }}</span>
                    </div>
                  </div>
                </div>

                <div v-bind:class="{'error' : form_valid_info.problem}" class="form-group row">
                  <label for="select-problem" class="col-sm-12 control-label">{{ $t("Details of problem") }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select v-model="selected_problem" id="select-problem" class="form-control btn-rounded">
                        <option disabled value="0">{{ $t("Please select cause") }}</option>
                        <option v-for="(problem, index) in problems" :value="index + 1">{{ problem.depth - 1 | depthFilter }}{{ problem.name }}</option>
                        <!--<option v-for="(problem, index) in problems" :value="index + 1">{{ problem.name }}</option>-->
                      </select>
                    </div>
                    <div class="help-block">
                      <ul role="alert">
                        <li v-for="msg in form_valid_info.problem"><small>{{ msg }}</small></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="explanation" class="col-sm-12 control-label">{{ $t("Explanation") }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <textarea v-model="explanation" id="explanation" class="form-control" rows="5" :placeholder="$t('Please give a short explanation of this problem...')"></textarea>
                    </div>
                  </div>
                </div>

                <div class="form-group row m-b-0">
                  <label for="loss" class="col-sm-8 control-label">{{ $t("Total loss due to this cause") }}</label>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <input v-model="loss" id="loss" class="form-control" type="text">
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="loss" class="col-sm-12 control-label text-muted text-right">{{ kpi_unit }}</label>
                </div>

                <div class="form-group row m-b-0">
                  <div class="col-sm-6">
                    <button @click="report_problem" type="submit" class="btn btn-sm btn-rounded btn-info">{{ $t("Report problem") }}</button>
                  </div>

                  <div class="col-sm-6 vb text-right">
                    <a @click="close" class="col-sm-6">{{ $t("Close dialog") }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </transition>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";

  export default {
    props: {
      kpi_uid: {
        default: null
      },
      kpi_name: {
        default: ''
      },
      kpi_units: {
        default: []
      }
    },
    name: "ReportProblemModal",
    data: function() {
      return {
        kpi: this.kpi_uid,
        name: this.kpi_name,
        kpi_unit: this.kpi_units.unit,
        problems: [],
        selected_problem: 0,
        date_time: moment().calendar().replace(' at', ''),
        explanation: "",
        loss: 0,
        form_valid_info: []
      }
    },
    created() {
      this.grab_problems();
    },
    methods: {
      grab_problems: function() {
        let vm = this;

        apiHelper.getResource("/api/kpi/" + vm.kpi + "/problem-causes").then((data) => {
          vm.problems = data;
        });
      },

      report_problem: function() {
        let vm = this;

        if (vm.selected_problem !== 0) {

          vm.form_valid_info = [];

          let data_to_send = {
            'loss': vm.loss,
            'note': vm.explanation
          };

          apiHelper.postResource("/api/kpi/" + vm.kpi + /problem/ + vm.problems[vm.selected_problem - 1].uid, data_to_send).then((data) => {

            vm.$notify({
              group: 'notification',
              title: vm.$t("Success"),
              text: vm.$t("Problem reported successfully"),
              type: "success"
            });
            vm.close();
          });
        } else {
          let problem = [];
          vm.form_valid_info = {};
          problem.push("Please select a problem first");
          vm.form_valid_info['problem'] = problem;

        }
      },

      // Close function
      close: function() {
        this.$emit('close');
      }
    },
    // So that if we press esc the modal closes
    mounted: function () {
      let vm = this;
      document.addEventListener("keydown", (event) => {
        if (event.key === 'Escape') {
          vm.close();
        }
      });
    },
    watch: {
      kpi_uid: function (value) {
        let vm = this;
        vm.kpi = value;
        vm.grab_problems();
      },
      selected_problem: function (value) {
        if (value !== 0) {
          this.form_valid_info = [];
        }
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportProblemModal.vue